import React, { useState, useEffect } from 'react'
import { OverlayTrigger, Tooltip, Table, Row, Col } from 'react-bootstrap'
// import { v4 as uuidv4 } from 'uuid'
// import { CSVLink } from 'react-csv'
import ExportExcel from '../ExportExcel'

const GroupPowerFans = ({ incLastData, csvDate, csvData }) => {
  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      這個指標能夠告訴您旗下所有子品牌/企業，在不同社群來源下所累積的總粉絲數。
    </Tooltip>
  )

  let totalFanCount = 0
  incLastData.forEach((element) => {
    totalFanCount += element.count_fans
    return totalFanCount
  })
  // 這樣寫更簡潔
  // const totalFanCount = incLastData.reduce((total, element) => total + element.count_fans, 0);
  const totalFBFanCount = incLastData.reduce(
    (total, element) => total + element.count_fb,
    0
  )
  const totalIGFanCount = incLastData.reduce(
    (total, element) => total + element.count_ig,
    0
  )
  const totalYTFanCount = incLastData.reduce(
    (total, element) => total + element.count_yt,
    0
  )

const [downloadData, setDownloadData] = useState([])

useEffect(() => {
  setDownloadData([
      {
        sheetName: '全品牌粉絲數',
        thead: ['類別', '數量(人)'],
        tbody: [
          ['粉絲總數量', totalFanCount],
          ['FB 追蹤者', totalFBFanCount],
          ['IG 追蹤者', totalIGFanCount],
          ['YT 訂閱者', totalYTFanCount],
        ],
        columnWidths: [
          { number: 1, width: 20 },
          { number: 2, width: 20 },
        ],
        tabColor: { argb: 'FF00FF00' },
      },
      {
        sheetName: '整體表現',
        thead: ['排名', '品牌', '分數'],
        tbody: csvData.totallyPerformance.map((v, i) => {
          return [i + 1, v.kol_name, v.totally_performance]
        }),
        columnWidths: [
          { number: 1, width: 10 },
          { number: 2, width: 30 },
          { number: 3, width: 10 },
        ],
      },
      {
        sheetName: '影響擴散力',
        thead: ['排名', '品牌', '分數'],
        tbody: csvData.sumfocVal.map((v, i) => {
          return [i + 1, v.kol_name, v.sumfoc_val]
        }),
        columnWidths: [
          { number: 1, width: 10 },
          { number: 2, width: 30 },
          { number: 3, width: 10 },
        ],
      },
      {
        sheetName: '話題創造力',
        thead: ['排名', '品牌', '分數'],
        tbody: csvData.avefocVal.map((v, i) => {
          return [i + 1, v.kol_name, v.avefoc_val]
        }),
        columnWidths: [
          { number: 1, width: 10 },
          { number: 2, width: 30 },
          { number: 3, width: 10 },
        ],
      },
      {
        sheetName: '好感渲染力',
        thead: ['排名', '品牌', '分數'],
        tbody: csvData.emofocVal.map((v, i) => {
          return [i + 1, v.kol_name, v.emofoc_val]
        }),
        columnWidths: [
          { number: 1, width: 10 },
          { number: 2, width: 30 },
          { number: 3, width: 10 },
        ],
      },
      {
        sheetName: '新粉吸引力',
        thead: ['排名', '品牌', '分數'],
        tbody: csvData.newattVal.map((v, i) => {
          return [i + 1, v.kol_name, v.newatt_val]
        }),
        columnWidths: [
          { number: 1, width: 10 },
          { number: 2, width: 30 },
          { number: 3, width: 10 },
        ],
      },
      {
        sheetName: '社群觸及力',
        thead: ['排名', '品牌', '分數'],
        tbody: csvData.fanresVal.map((v, i) => {
          return [i + 1, v.kol_name, v.fanres_val]
        }),
        columnWidths: [
          { number: 1, width: 10 },
          { number: 2, width: 30 },
          { number: 3, width: 10 },
        ],
      },
    ])
}, [csvData])




  return (
    <>
      <Row className="mt-3">
        <Col>
          <h4 className="fw-bolder p-3">
            全品牌粉絲數
            <OverlayTrigger
              placement="right"
              delay={{ show: 50, hide: 400 }}
              overlay={renderTooltip}
            >
              <div
                className="fas fa-question-circle p-1 text-decoration-none"
                data-bs-toggle="tooltip"
                data-bs-placement="right"
              ></div>
            </OverlayTrigger>
          </h4>
        </Col>
        <Col>
          <h4 className="fw-bolder p-3">
            報表下載{' '}
            <ExportExcel
              fileName={`綜合分析報表-${csvDate}.csv`}
              sheetDatas={downloadData}
            ></ExportExcel>
          </h4>
        </Col>
      </Row>
      <hr />
      <Table striped hover className="mt-0">
        <thead>
          <tr>
            <th scope="col" className="fs-5">
              <h5 className="fw-bolder">粉絲總數量</h5>
            </th>

            <th>
              <h5 className="fw-bolder">{totalFanCount}</h5>
            </th>
          </tr>
        </thead>
        <tbody className="table-group-divider">
          <tr>
            <th scope="row">FB 按讚數</th>
            <td>{totalFBFanCount}</td>
          </tr>
          <tr>
            <th scope="row">IG 追蹤者</th>
            <td>{totalIGFanCount}</td>
          </tr>
          <tr>
            <th scope="row">YT 訂閱者</th>
            <td>{totalYTFanCount}</td>
          </tr>
        </tbody>
      </Table>
    </>
  )
}

export default GroupPowerFans
